module.exports = __webpack_public_path__ + "img/attachments_0.44b6f37b.svg";